<template>
    <div class="mt-5">
        <div v-if="selected_rewards.length > 0" class="flex space-x-2 mt-5">
            <div>
                <div>
                    <BadgePill color="green" class="text-lg" v-if="totalRewardsExperience > 0">
                        {{ totalRewardsExperience }}
                    </BadgePill>
                </div>
            </div>
            <AppButton @click="giveRewards()" element="button" desired-action>
                {{ $t('messages.assign_points') }}
            </AppButton>
        </div>
        <EmptyState picture v-if="rewards.length === 0" />
        <div v-else class="grid grid-cols-2 md:grid-cols-4 sm:grid-cols-3 gap-3 md:gap-6 mt-5">
            <div v-for="reward in rewards" class="flex flex-col mt-5 sm:mt-0" :key="reward.id">
                <div class="text-sm">
                    <div class="flex space-x-2">
                        <input
                            type="checkbox"
                            name="selected_rewards"
                            v-model="selected_rewards"
                            :value="reward.id"
                            :id="`reward_${reward.id}`"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                        />

                        <label :for="`reward_${reward.id}`">
                            <span v-if="reward.creates_foul" :title="reward.creates_foul_info">
                                <svg
                                    class="inline-block h-4 w-4 text-gray-600 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                    stroke="none"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M18.615 3.13745H5.38496C4.11496 3.13745 3.08496 4.16745 3.08496 5.43745V18.6675C3.08496 19.9375 4.11496 20.9675 5.38496 20.9675H18.615C19.885 20.9675 20.915 19.9375 20.915 18.6675V5.43745C20.915 4.16745 19.885 3.13745 18.615 3.13745ZM19.715 18.6575C19.715 19.2675 19.225 19.7575 18.615 19.7575H5.38496C4.77496 19.7575 4.28496 19.2675 4.28496 18.6575V5.43745C4.28496 4.82745 4.77496 4.33745 5.38496 4.33745H18.615C19.225 4.33745 19.715 4.82745 19.715 5.43745V18.6575ZM12.5149 5.26758H11.4849C10.9749 5.26758 10.4749 5.48758 10.1249 5.87758C9.75494 6.28758 9.56494 6.85758 9.62494 7.41758L10.1349 12.4076C10.2349 13.3976 11.0349 14.1476 11.9949 14.1476C12.9549 14.1476 13.7449 13.3976 13.8549 12.4076L14.3649 7.41758C14.4249 6.84758 14.2449 6.28758 13.8649 5.87758C13.5249 5.49758 13.0249 5.26758 12.5149 5.26758ZM12.6649 12.2876C12.6249 12.6676 12.3449 12.9476 12.0049 12.9476C11.6649 12.9476 11.3849 12.6676 11.3449 12.2876L10.8349 7.29758C10.8149 7.06758 10.8849 6.84758 11.0249 6.67758C11.1549 6.53758 11.3149 6.45758 11.4949 6.45758H12.5249C12.7049 6.45758 12.8649 6.53758 12.9949 6.67758C13.1449 6.83758 13.2149 7.06758 13.1849 7.29758L12.6649 12.2876ZM10.205 16.9775C10.205 15.9875 11.015 15.1875 12.005 15.1875C12.995 15.1875 13.805 15.9875 13.805 16.9775C13.805 17.9675 12.995 18.7675 12.005 18.7675C11.015 18.7675 10.205 17.9675 10.205 16.9775ZM11.205 16.9775C11.205 17.4075 11.565 17.7675 12.005 17.7675C12.445 17.7675 12.805 17.4175 12.805 16.9775C12.805 16.5475 12.445 16.1875 12.005 16.1875C11.565 16.1875 11.205 16.5375 11.205 16.9775Z"
                                    />
                                </svg>
                            </span>

                            <span class="text-sm md:text-base">{{ reward.title }}</span>
                        </label>
                    </div>
                </div>
                <div class="mt-2">
                    <div
                        @click="giveReward(reward)"
                        :class="[
                            reward.is_negative ? 'bg-red-500' : 'bg-indigo-500',
                            selected_rewards.length === 0 ? 'cursor-pointer' : '',
                        ]"
                        class="shrink-0 flex items-center justify-center h-16 w-full rounded-lg aspect-w-1 aspect-h-1"
                    >
                        <img v-if="reward.image_path" :src="reward.image_path" alt="" />
                    </div>
                </div>
                <div class="flex justify-between mt-2">
                    <div>
                        <BadgePill color="green" class="text-lg" v-if="reward.experience_amount !== null">
                            {{ reward.experience_amount }}
                        </BadgePill>
                    </div>
                    <div>
                        <BadgePill color="red" class="text-lg" v-if="reward.health_amount !== null">
                            {{ reward.health_amount }}
                        </BadgePill>
                    </div>
                    <div>
                        <BadgePill color="yellow" class="text-lg" v-if="reward.coins_amount !== null">
                            {{ reward.coins_amount }}
                        </BadgePill>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppButton from '@/components/AppButton.vue';
import BadgePill from '@/components/BadgePill.vue';
import EmptyState from '@/components/EmptyState.vue';

export default {
    emits: ['close'],
    name: 'GiveRewardCurrencyPointsForm',

    components: {
        EmptyState,
        AppButton,
        BadgePill,
    },

    props: {
        students: {
            required: true,
            type: [Object, Array],
        },
        rewards: {
            required: true,
            type: Array,
        },
    },

    data() {
        return {
            selected_rewards: [],
        };
    },

    computed: {
        selectedStudentsIds: function () {
            return this.selectedStudents.map((s) => s.id);
        },
        selectedStudents: function () {
            if (Array.isArray(this.students)) {
                return this.students;
            }

            if (typeof this.students === 'object') {
                return [this.students];
            }

            return this.students;
        },
        totalRewardsExperience: function () {
            return this.rewards
                .filter((r) => this.selected_rewards.includes(r.id))
                .filter((r) => r.experience_amount)
                .map((r) => r.experience_amount)
                .reduce((a, b) => a + b, 0);
        },
    },

    methods: {
        giveRewards() {
            if (this.selected_rewards.length === 0) {
                return;
            }

            const url = route('gamification.reward_currency_points.store');
            const data = {
                student_ids: this.selectedStudentsIds,
                gamification_reward_ids: this.selected_rewards,
            };
            this.$inertia.post(url, data, {
                onSuccess: () => {
                    this.$emit('close');
                    this.selected_rewards = [];
                },
                preserveScroll: true,
            });
        },
        giveReward(reward) {
            if (this.selected_rewards.length > 0) {
                return;
            }

            const url = route('gamification.reward_currency_points.store');
            const data = {
                student_ids: this.selectedStudentsIds,
                gamification_reward_ids: [reward.id],
            };
            this.$inertia.post(url, data, {
                onSuccess: () => {
                    this.$emit('close');
                    this.selected_rewards = [];
                },
                preserveScroll: true,
            });
        },
    },
};
</script>
